// used by Selenium and guided tour to target elements
export var ElementId;
(function (ElementId) {
    ElementId["NavigationMenu"] = "NavigationMenu";
    ElementId["AddNew"] = "AddNew";
    ElementId["AddNewSequencedContent"] = "AddNewSequencedContent";
    ElementId["AddNewNonSequencedContent"] = "AddNewNonSequencedContent";
    ElementId["AddNewQuiz"] = "AddNewQuiz";
    ElementId["AddNewSubmenu"] = "AddNewSubmenu";
    ElementId["EditSqItemName"] = "EditSqItemName";
    ElementId["AddNewItemButton"] = "AddNewItemButton";
    ElementId["AddNewAction"] = "AddNewAction";
    ElementId["AddNewQuestion"] = "AddNewQuestion";
    ElementId["AddNewSplitSequence"] = "AddNewSplitSequence";
    ElementId["RestartGuidedTour"] = "RestartGuidedTour";
    ElementId["Loader"] = "Loader";
    ElementId["NextNavigationButton"] = "NextNavigationButton";
    ElementId["FinishNavigationButton"] = "FinishNavigationButton";
})(ElementId || (ElementId = {}));
